import React from 'react';

const FAQItem = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 mb-4">
      <button
        onClick={onToggle}
        className="w-full text-left p-6 flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800"
      >
        <h3 className="text-lg font-medium text-neutral-900 dark:text-white">
          {question}
        </h3>
        <svg 
          className={`w-5 h-5 text-neutral-500 dark:text-neutral-400 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className="px-6 pb-6 pt-0 border-t border-neutral-200 dark:border-neutral-700">
          <p className="text-neutral-600 dark:text-neutral-400 mt-4">
            {answer}
          </p>
        </div>
      )}
    </div>
  );
};

export default FAQItem;